module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Select', {
    attrs: {
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onChange
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, _vm._l((_vm.channelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.channelParam
      }
    }, [_vm._v(_vm._s(item.id + '-' + item.channelName + ' - ' + _vm.$constant.getEnum(_vm.$constant.tchChannel, item.tchChannel).text) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9877a704","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ChannelSelect.vue
// module id = 1909
// module chunks = 8